import {
  GET_CLIENTS_ATTEMPT,
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_FAILURE,
} from "../constants";

import { ClientsInitialState } from "../../types/clients";

const initialState: ClientsInitialState = {
  fetchingClientsList: 0,
  errorMessage: "",
  success: true,
  clientsList: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getClients
    case GET_CLIENTS_ATTEMPT:
      return {
        ...state,
        fetchingClientsList: state.fetchingClientsList + 1,
        success: true,
        errorMessage: "",
      };
    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        fetchingClientsList: state.fetchingClientsList - 1,
        success: true,
        errorMessage: "",
        clientsList: validData(action.payload.data),
      };
    case GET_CLIENTS_FAILURE:
      return {
        ...state,
        fetchingClientsList: state.fetchingClientsList - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};

function validData (data: any[]) {
  return data.filter((element: any) => element.clientId)
}